
import TemplateForm from '../../features/admin/TemplateForm'

const TemplatePage = () => {
  return (
   <TemplateForm/>
  )
}

export default TemplatePage
